<template>
    <div class="rdv-w-layout-inner--appointment toggle-form-inner">
        <h2 class="wellcoming__form-title">Complétez vos informations pour être rappelé</h2>
        <p class="required-text">*Champs obligatoires</p>
        <form :action="route" method="POST" class="rdv-w-layout__form" @submit.prevent="submitForm" novalidate>
            <div class="rounded-grey-wrapper">
                <input type="hidden" name="appointment" value="appointment2" />

                <!-- Type de rendez-vous -->
                <div class="h-70">
                    <div class="form-title--content">Vos préférences de rendez-vous *</div>
                    <small v-if="v$.typeAppointment.$error"  class="ck-error-message">{{ v$.typeAppointment.$errors[0].$message }}</small>
                </div>
                <div class="form-radio_pointer white-bg form-radio_pointer--separated">
                    <input type="radio" id="contact-en_magasin" name="typeAppointment" value="in-store" v-model="v$.typeAppointment.$model" />
                    <label for="contact-en_magasin">En magasin</label>
                </div>
                <div class="form-radio_pointer white-bg form-radio_pointer--separated">
                    <input type="radio" id="contact-a_distance" name="typeAppointment" value="in-distance" v-model="v$.typeAppointment.$model" />
                    <label for="contact-a_distance">A distance</label>
                    <span class="pointer"></span>
                </div>

                <!-- Jours disponibles -->
                <div class="h-70">
                    <div class="form-title--content">Choisissez le ou les jours que vous souhaitez *</div>
                    <small v-if="v$.selectedDays.$error"  class="ck-error-message">{{ v$.selectedDays.$errors[0].$message }}</small>
                </div>
                <div class="timeslots timeslots--no-border">
                    <div class="timeslots__item">
                        <div v-if="availableDays.length > 0" class="timeslots__inner">
                            <div v-for="entry in availableDays" :key="entry.label" class="timeslots__slot">
                                <input type="checkbox" :id="`contact-day-${entry.label}`" :value="entry.value" v-model="v$.selectedDays.$model" />
                                <label :for="`contact-day-${entry.label}`">{{ entry.label }}</label>
                            </div>
                        </div>
                        <input type="hidden" :value="selectedDays" name="day" />
                    </div>
                </div>

                <!-- Heures disponibles -->
                <div class="h-70">
                    <div class="form-title--content">Et un créneau horaire *</div>
                    <small v-if="v$.selectedHours.$error"  class="ck-error-message">{{ v$.selectedHours.$errors[0].$message }}</small>
                </div>
                <div class="timeslots timeslots--no-border">
                    <div class="timeslots__item">
                        <div v-if="availableHours.length > 0" class="timeslots__inner timeslots__inner--large">
                            <div v-for="entry in availableHours" :key="entry.label" class="timeslots__slot">
                                <input type="checkbox" :id="`contact-hour-${entry.label}`" :value="entry.value" v-model="v$.selectedHours.$model" />
                                <label :for="`contact-hour-${entry.label}`">{{ entry.label }}</label>
                            </div>
                        </div>
                    </div>
                    <input type="hidden" :value="selectedHours" name="hour" />
                </div>

                <!-- Coordonnées -->
                <div class="form-grid">
                    <div class="form-grid__fields">
                        <p class="form-title form-title--strong">Vos coordonnées</p>
                        <div class="form-radio_pointer white-bg">
                            <input type="radio" id="contact-civility-madame" name="civility" value="madame" v-model="v$.civility.$model" />
                            <label for="contact-civility-madame">Madame</label>

                            <input type="radio" id="contact-civility-monsieur" name="civility" value="monsieur" v-model="v$.civility.$model" />
                            <label for="contact-civility-monsieur">Monsieur</label>
                            <span class="pointer"></span>
                        </div>

                        <div class="form-row">
                            <div class="form-group">
                                <label for="contact-firstName" class="sr-only">Votre prénom</label>
                                <input :class="{ 'input-error': v$.firstName.$error }" type="text" id="contact-firstName" name="firstName" :placeholder="'Votre prénom *'" v-model="v$.firstName.$model" aria-describedby="info-firstName__errors" />
                                <div id="info-firstName__errors">
                                    <small v-if="v$.firstName.$error" class="ck-error-message">{{ v$.firstName.$errors[0].$message }}</small>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="contact-lastName" class="sr-only">Votre nom</label>
                                <input :class="{ 'input-error': v$.lastName.$error }" type="text" id="contact-lastName" name="lastName" :placeholder="'Votre nom *'" v-model="v$.lastName.$model" aria-describedby="info-lastName__errors" />
                                <div id="info-lastName__errors">
                                    <small v-if="v$.lastName.$error" class="ck-error-message">{{ v$.lastName.$errors[0].$message }}</small>
                                </div>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group">
                                <label for="contact-email" class="sr-only">Votre email</label>
                                <input :class="{ 'input-error': v$.email.$error }" type="email" id="contact-email" name="email" :placeholder="'Votre email *'" v-model="v$.email.$model" aria-describedby="info-email__errors" />
                                <div id="info-email__errors">
                                    <small v-if="v$.email.$error" class="ck-error-message">{{ v$.email.$errors[0].$message }}</small>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="contact-mobilePhone" class="sr-only">Votre téléphone</label>
                                <IntlTelInputCustom
                                    v-model="mobilePhone"
                                    :id="'contact-mobilePhone'"
                                    :aria-describedby="'info-mobilePhone__errors'"
                                    :error="v$.mobilePhone.$error"
                                    :required="false"
                                    @changeNumber="mobilePhone = $event"
                                    @changeValidity="v => phoneValid = v"
                                    @blur="v$.mobilePhone.$touch()"
                                />
                                <div id="info-mobile__errors">
                                    <small v-if="v$.mobilePhone.$error" class="ck-error-message">{{ v$.mobilePhone.$errors[0].$message }}</small>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <p class="commercial-info">J’accepte d’être contacté(e) pour être informé(e) des
                                nouveautés et des bons plans :</p>
                            <div class="form-item-row form-checkbox-communication form-checkbox_pointer">

                                <div class="form-item">
                                    <input
                                        type="checkbox"
                                        id="infos-communication-sms-callback"
                                        name="isSmsAllowed"
                                        v-model="isSmsAllowed"
                                    />
                                    <label class="communication-calendar" for="infos-communication-sms-callback">Par SMS</label>
                                </div>
                                <div class="form-item">
                                    <input
                                        type="checkbox"
                                        id="infos-communication-email-callback"
                                        name="isEmailAllowed"
                                        v-model="isEmailAllowed"
                                    />
                                    <label class="communication-calendar" for="infos-communication-email-callback">Par Email</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Store info en attente d'intégration -->
                    <div class="form-grid__store">
                        <p class="form-title form-title--strong">Votre magasin</p>
                        <div class="store-card">
                            <div class="store-card__left" v-if="store">
                                <p class="store-card__title">{{ stores[store]?.name }}</p>
                                <p class="store-card__address">
                                    {{ stores[store]?.streetAddress }}<br/>
                                    {{ stores[store]?.postalCode }}  {{ stores[store]?.locality }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="rdv-w-layout__sticky-btn">
                <button type="submit" class="btn submit-btn">
                    Valider
                </button>
            </div>

            <p class="form-info">
                Les données recueillies par le biais du formulaire ci-dessus permettront à la société nom de la société CKBF (488 052 150 RCS Bobigny) qui anime le réseau de distribution Cake Kitchen (ci-après « l’Enseigne »), et au franchisé sélectionné à la page précédente (ci-après le « Magasin ») de fixer un rendez-vous entre vous et le Magasin et si vous avez coché la case « par SMS » et/ou « par Email », de vous envoyer, selon le(s) moyen(s) au(x)quel(s) vous avez consenti (courriel ou sms), des informations et offres promotionnelles. Elles permettront également de vous contacter, afin de réaliser des enquêtes, à la suite de ce rendez-vous et éventuellement à vous inviter à partage votre avis. Elles permettront également de réaliser différentes statistiques.
            </p>
            <p class="form-info">
                Vous disposez de droits d’accès, de rectification, de limitation, de portabilité, d’opposition et de suppression de vos données personnelles que vous pouvez exercer en cliquant <a href="https://www.cakekitchen.fr/exercice-de-droit" target="_blank" >ici</a>.
            </p>
            <p class="form-info">
                <u><a href="https://www.cakekitchen.fr/mentions-rdv"  target="_blank">En Savoir plus</a></u>
            </p>
            <p class="form-info">
                Tout consommateur qui ne souhaite pas faire l’objet d’une prospection commerciale par voie téléphonique peut s’inscrire gratuitement sur la liste d’opposition au démarchage téléphonique à l’adresse suivante : <a href="https://www.bloctel.gouv.fr" target="_blank">https://www.bloctel.gouv.fr</a>
            </p>

        </form>
    </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core';
import { required, helpers } from '@vuelidate/validators';
import { isValidFirstName, isValidLastName, isValidEmail, hasNoAccents } from '../../views/modules/wellcoming/scripts/helpers/helpers';
import axios from "axios";
import IntlTelInputCustom from "../components/IntlTelInputCustom.vue";

export default {
    name: 'CalendarCallback',
    components: {IntlTelInputCustom},
    props: {
        step: String,
        stores: Object,
        route: {
            type: String,
            default : '#'
        },
        csrfToken: {
            type: String,
            required: true
        }
    },
    setup () {
        return {
            v$: useVuelidate(),
            iti: null
        }
    },
    data() {
        return {
            availableDays: [
                {label: "Lun", value: "Lundi"},
                {label: "Mar", value: "Mardi"},
                {label: "Mer", value: "Mercredi"},
                {label: "Jeu", value: "Jeudi"},
                {label: "Ven", value: "Vendredi"},
                {label: "Sam", value: "Samedi"},
                {label: "Dim", value: "Dimanche"},
            ],
            availableHours: [
                {label: "10h - 12h", value: "10h - 12h"},
                {label: "12h - 14h", value: "12h - 14h"},
                {label: "14h - 17h", value: "14h - 17h"},
                {label: "17h - 20h", value: "17h - 20h"},
            ],
            selectedDays: [],
            selectedHours:  [],
            civility: 'madame',
            firstName:null,
            lastName: null,
            email: null,
            mobilePhone: null,
            isSmsAllowed: false,
            isEmailAllowed: false,
            typeAppointment: null,
            store: null,
            phoneValid : false,
        }
    },
    validations() {
        return {
            selectedDays: {
                required: helpers.withMessage('Veuillez sélectionner un jour', required)
            },
            selectedHours: {
                required: helpers.withMessage('Veuillez sélectionner un créneau horaire', required)
            },
            typeAppointment: {
                required: helpers.withMessage('Veuillez sélectionner un lieu de rendez-vous', required)
            },
            civility: {
                required: helpers.withMessage('Veuillez sélectionner une civilité', required)
            },
            firstName: {
                required: helpers.withMessage('Le champ prénom est obligatoire', required),
                isValid: helpers.withMessage('Veuillez saisir un prénom valide', isValidFirstName),
            },
            lastName: {
                required: helpers.withMessage('Le champ nom est obligatoire', required),
                hasNoAccents: helpers.withMessage('Les accents ne sont pas autorisés dans le nom', hasNoAccents),
                isValid: helpers.withMessage('Veuillez saisir un nom valide', isValidLastName),
            },
            email: {
                required: helpers.withMessage('Le champ email est obligatoire', required),
                isValidEmail: helpers.withMessage('Veuillez saisir un email valide', isValidEmail),
            },
            mobilePhone: {
                required : helpers.withMessage('Le champ telephone est obligatoire', required),
                isValidPhoneNumber : helpers.withMessage('Veuillez saisir un numéro de téléphone valide', this.isValidMobilePhone)
            }
        }
    },
    methods: {
        isValidMobilePhone(){
            return this.phoneValid;
        },
        onStoreChange(e) {
            // à chaque changement, on met à jour la donnée réactive
            this.store = e.target.value;
        },
        onVisible(){
            this.addDataLayer("callback_infos");
        },
        addDataLayer(step) {
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
                "event": "page_view",
                "chapter1": "",
                "chapter2": "",
                "chapter3": "",
                "step": step,
            });
            console.info("[GTM] Following data was added to dataLayer:")
            console.table(dataLayer)
        },
        async submitForm() {
            this.v$.$touch(); // Valide tous les champs

            if (this.v$.$invalid) {
                this.$nextTick(() => {
                    this.$el.querySelector('.input-error, .ck-error-message')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                });
                return;
            }

            try {
                startOverlay();

                const formData = new FormData();
                formData.append('_token', this.csrfToken);
                formData.append('appointment', 'appointment2');
                formData.append('day', this.selectedDays);
                formData.append('typeAppointment', this.typeAppointment);
                formData.append('hour', this.selectedHours);
                formData.append('civility', this.civility);
                formData.append('firstName', this.firstName);
                formData.append('lastName', this.lastName);
                formData.append('email', this.email);
                formData.append('mobilePhone', this.mobilePhone);
                formData.append('storeCode', this.store);
                formData.append('isSmsAllowed', this.isSmsAllowed ? 1 : 0);
                formData.append('isEmailAllowed', this.isEmailAllowed ? 1 : 0);

                const response = await axios.post(this.route, formData, {
                    headers: {
                        'X-CSRF-TOKEN': this.csrfToken,
                    },
                });

                this.$emit('first-name', this.firstName);
                this.$emit('store-choose', this.store);
                this.$emit('go-to-step', 'APPOINTMENT_ASKED');
                window.dataLayer = window.dataLayer || [];
                dataLayer.push({
                    "event": "page_view",
                    "chapter1": "",
                    "chapter2": "",
                    "chapter3": "",
                    "step": this.typeAppointment,
                });

            } catch (error) {
                console.error('Erreur API:', error.response?.data || error.message);
            } finally {
                stopOverlay();
            }
        },

    },
    mounted(){
        this.radioEls = Array.from(
            document.querySelectorAll("input[name='store_code']")
        );
        // on initialise la valeur si un radio est déjà coché
        const initial = document.querySelector("input[name='store_code']:checked");
        if (initial) this.store = initial.value;

        // on bind la méthode
        this.onStoreChange = this.onStoreChange.bind(this);
        // on écoute l'événement change sur chacun
        this.radioEls.forEach(el => {
            el.addEventListener('change', this.onStoreChange);
        });
    },
    beforeUnmount() {
        // on détache proprement les écouteurs
        this.radioEls.forEach(el => {
            el.removeEventListener('change', this.onStoreChange);
        });
    },
    watch: {
        step(newStep) {
            if (newStep === 'CALLBACK_INFO') {
                this.$nextTick(() => {
                    this.onVisible();
                });
            }
        }
    }
};
</script>
<style>
</style>
